var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("GenericProps", {
        attrs: {
          "node-id": _vm.node.id,
          settings: _vm.settings,
          "audio-parameters": _vm.audioParameters,
          parameters: _vm.filteredNodeParameters
        },
        on: {
          "update:settings": [
            function($event) {
              _vm.settings = $event
            },
            _vm.updateNodeParent
          ]
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }